import request from '@/http/request';

// 获取合作单位列表
export function getPartnerList(params) {
  return request({
    url: '/api/v1/ops/partner_list',
    method: 'get',
    params,
  });
}

// 创建合作单位信息
export function createPartner(data) {
  return request({
    url: '/api/v1/ops/partner_create',
    method: 'post',
    data,
  });
}

// 更新合作单位信息
export function updatePartner(partnerId, data) {
  return request({
    url: `/api/v1/ops/partner_update/${partnerId}`,
    method: 'put',
    data,
  });
}

// 删除合作单位信息
export function deletePartner(partnerId) {
  return request({
    url: `/api/v1/ops/partner_delete/${partnerId}`,
    method: 'delete',
  });
}

// 根据合作单位ID获取详情
export function getPartnerDetail(partnerId) {
  return request({
    url: `/api/v1/ops/partner/${partnerId}`,
    method: 'get',
  });
}

// 根据合作单位ID查询操作日志
export function getPartnerHistory(partnerId) {
  return request({
    url: `/api/v1/ops/partner_logs/${partnerId}`,
    method: 'get',
  });
}